




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import GlobalMixins from "@/global.mixin";
import { State} from "vuex-class";

@Component({
  mixins: [GlobalMixins]
})
export default class PrintLabelDialog extends Vue {
  @Prop({ type: Boolean, default: false }) value!: boolean;
  @Prop({ type: Object, default: null }) product!: any;

  @State("socketState") socketState: any;

  dialog = false;
  loading = false;
  barCode = "";
  productName = "";

  @Watch("value")
  onValueChange(newVal: boolean) {
    this.dialog = newVal;
    if (newVal && this.product) {
      this.barCode = this.product.barCode || "";
      this.productName = this.product.description || "";
    }
  }

  @Watch("dialog")
  onDialogChange(newVal: boolean) {
    this.$emit("input", newVal);
  }

  close() {
    this.dialog = false;
  }

  printLabel() {
    this.loading = true;
    // Here you would implement the actual label printing logic
    // For now, we'll just simulate a print operation
    setTimeout(() => {
      this.loading = false;
      this.$emit("print-label", {
        barCode: this.barCode,
        productName: this.productName
      });
      this.close();
    }, 1000);
  }

  labelPrinterStatus() {
    if ( this.socketState.connected) {
      return this.$t("LABEL_PRINTER_AVAILABLE");
    } else {
      return this.$t("LABEL_PRINTER_UNAVAILABLE") + "<br> Próbáld meg frissíteni a weboldalt.";
    }
  }
}
